/**
 * データ表のキーボードショートカットヒント（既定は折りたたみ1行）
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './KeisukeDashboardCenterPane.module.scss';

type Props = {
  visible?: boolean;
  /** 末尾に足すコンパクト表向けの補足（生存・用量など） */
  trailingHint?: string;
};

function HintSep() {
  return (
    <span className={styles.clipboardHintSep} aria-hidden>
      ·
    </span>
  );
}

export default function KeisukeClipboardHintBar({
  visible = true,
  trailingHint,
}: Props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  if (!visible) return null;

  return (
    <details
      className={styles.clipboardHintDetails}
      open={open}
      onToggle={(e) => setOpen((e.currentTarget as HTMLDetailsElement).open)}
    >
      <summary className={styles.clipboardHintSummary}>
        <i className="fas fa-keyboard" aria-hidden />
        <span>{t('keisuke.dashboard.clipboardBar.summary')}</span>
      </summary>
      <div className={styles.clipboardHintBar}>
        <span>{t('keisuke.dashboard.clipboardBar.drag')}</span>
        <kbd>Shift</kbd>
        <span>{t('keisuke.dashboard.clipboardBar.shiftClickSelect')}</span>
        <HintSep />
        <kbd>Ctrl+C</kbd>
        <span>{t('keisuke.dashboard.clipboardBar.copy')}</span>
        <HintSep />
        <kbd>Ctrl+V</kbd>
        <span>{t('keisuke.dashboard.clipboardBar.paste')}</span>
        <HintSep />
        {trailingHint ? (
          <span>{trailingHint}</span>
        ) : (
          <>
            <kbd>Del</kbd>
            <span>{t('keisuke.dashboard.clipboardBar.deleteRange')}</span>
            <HintSep />
            <kbd>Ctrl+Home</kbd>
            <kbd>Ctrl+End</kbd>
            <span>{t('keisuke.dashboard.clipboardBar.jumpEnds')}</span>
            <HintSep />
            <kbd>Esc</kbd>
            <span>{t('keisuke.dashboard.clipboardBar.clearSelection')}</span>
          </>
        )}
      </div>
    </details>
  );
}
